/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response to update the phone of a person
 * @export
 * @interface UpdatePhonePwrResponse
 */
export interface UpdatePhonePwrResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdatePhonePwrResponse
     */
    phoneId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePhonePwrResponse
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePhonePwrResponse
     */
    prefixPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePhonePwrResponse
     */
    note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePhonePwrResponse
     */
    isMobile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePhonePwrResponse
     */
    isFavorite?: boolean;
}

/**
 * Check if a given object implements the UpdatePhonePwrResponse interface.
 */
export function instanceOfUpdatePhonePwrResponse(value: object): value is UpdatePhonePwrResponse {
    return true;
}

export function UpdatePhonePwrResponseFromJSON(json: any): UpdatePhonePwrResponse {
    return UpdatePhonePwrResponseFromJSONTyped(json, false);
}

export function UpdatePhonePwrResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePhonePwrResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'phoneId': json['phoneId'] == null ? undefined : json['phoneId'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'prefixPhone': json['prefixPhone'] == null ? undefined : json['prefixPhone'],
        'note': json['note'] == null ? undefined : json['note'],
        'isMobile': json['isMobile'] == null ? undefined : json['isMobile'],
        'isFavorite': json['isFavorite'] == null ? undefined : json['isFavorite'],
    };
}

export function UpdatePhonePwrResponseToJSON(json: any): UpdatePhonePwrResponse {
    return UpdatePhonePwrResponseToJSONTyped(json, false);
}

export function UpdatePhonePwrResponseToJSONTyped(value?: UpdatePhonePwrResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phoneId': value['phoneId'],
        'phone': value['phone'],
        'prefixPhone': value['prefixPhone'],
        'note': value['note'],
        'isMobile': value['isMobile'],
        'isFavorite': value['isFavorite'],
    };
}

